import React, { Component, Context, useContext, useEffect, useState } from "react";
import { connect } from "react-redux";
import { WidgetProps } from "../widgets";
import AppContext, { IAppContext } from "../../contexts/app/AppContext";
import { IFooterState, mapFooterStateToProps } from "../../redux/reducers/footer";
import { IFooterActionDispatches, mapFooterDispatchToProps } from "../../redux/actions/footer";
import { SocialLinks } from "../layout/Footer";
import socialCollage from "../../assets/socialCollage.png";
import "./Socials.scss";

type SocialsWidgetProps = {} & WidgetProps;

class SocialsWidget extends Component<IFooterState & IFooterActionDispatches & SocialsWidgetProps> {
	static contextType: Context<IAppContext> = AppContext;

	render() {
		return (
			<div className="socials-container">
				<div className="container d-flex flex-column flex-md-row align-items-center">
					<div className="w-100-xs w-50">
						<h1>Connect With Us</h1>
						<SocialLinks
							{...this.props}
							classes="d-flex flex-row-reverse justify-content-center justify-content-md-end mt-4 mb-5 orange-link"
							withEmail
							withInstagramTextLink
						/>
					</div>
					<div className="socials-collage d-flex align-items-end">
						<img className="collage-bg d-none d-md-inline-block" src={socialCollage} />
						<img src={socialCollage} />
					</div>
				</div>
			</div>
		);
	}
}

export default connect<IFooterState, IFooterActionDispatches, SocialsWidgetProps>(
	mapFooterStateToProps,
	mapFooterDispatchToProps
)(SocialsWidget);
